export const getCurrentLang = pathname => {
  const match = pathname.match(/^\/(en|hy|ru|es)(\/|$)/);
  return match ? match[1] : 'en';
};

/**
 * Prefixes a path with the current language from the URL.
 *
 * Always returns a trailing slash. The server serves every route's
 * prerendered HTML from a directory (e.g. build/en/team/index.html), so a
 * request for the no-slash form (/en/team) gets a 301 to the slash form
 * (/en/team/) before it ever reaches the page. Every internal link in the
 * app goes through this helper, so without this normalization every nav
 * click, footer link, and practice-area card was sending real visitors and
 * crawlers through an avoidable extra redirect hop on every single page -
 * see Search Console's "Page with redirect" report, which was dominated by
 * exactly these URLs.
 */
export const withLang = (pathname, path) => {
  const lang = getCurrentLang(pathname);
  const normalizedPath = path.endsWith('/') ? path : `${path}/`;
  return `/${lang}${normalizedPath}`;
};
